import { Component, Inject, OnInit, Optional } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-finetune-example-editor',
  templateUrl: './finetune-example-editor.component.html',
  styleUrls: ['./finetune-example-editor.component.css'],
  standalone: false,
})
export class FinetuneExampleEditorComponent implements OnInit {
  form;
  loading = false;
  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote'],

      // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      // [{ 'direction': 'rtl' }],                         // text direction

      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      // [{ 'font': [] }],
      [{ align: [] }],

      ['clean'], // remove formatting button

      ['link'], // link and image, video
    ],
  };
  constructor(
    private fb: UntypedFormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() private dialogRef: MatDialogRef<FinetuneExampleEditorComponent>
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      input: [this.dialogData.input, [Validators.required]],
      output: [this.dialogData.output, [Validators.required]],
    });
  }

  saveExample() {
    if (this.dialogRef) {
      this.dialogRef.close({ ...this.form.value, id: this.dialogData.id });
    }
  }

  cancelAction() {
    if (this.dialogRef) {
      this.dialogRef.close({ id: this.dialogData.id, cancelled: true });
    }
  }

  deleteAction() {
    if (this.dialogRef) {
      this.dialogRef.close({ id: this.dialogData.id, deleted: true });
    }
  }
}
